// ---------------------------------------------------------
// Datei: auth.ts
// Zweck: Auth-bezogene Konfigurationswerte
// Besonderheiten:
// - Gemeinsame Gnadenfrist für Google One Tap, damit AuthContext
//   und LoginScreen synchron entscheiden, wann One Tap als
//   "nicht erfolgreich" gilt
// ---------------------------------------------------------

// Zeit, die Google One Tap zum stillen Anmelden bekommt, bevor
// die UI von einem nicht angemeldeten Zustand ausgeht.
export const ONE_TAP_GRACE_MS = 3000;
